import {Component, OnInit} from '@angular/core';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";

@Component({
  selector: 'pbc-check-bank',
  templateUrl: './check-bank.component.html',
  styleUrls: ["./check-bank.component.scss"]
})
export class CheckBankComponent implements OnInit {

  constructor(private breadcumbsService: BreadcumbsService) { }

  ngOnInit() {
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Sprawdzbank'),100);
  }

}
